import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 28 Mar 2026 22:35 PM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.3YwluljnZGvEjtTBdV8T9yR_d5pXzQSJzT7MZJGh2R-Qq1H2CtXghxrUNvSbfrcMjx2QySI6I6swpJisabmbbE6Omx4_nNu2cqRpgsoEPCc-dAgVCuIkA_xTa-UDnidfkz3L_BvBmofMOZ3ofkG2eOc-o5evoqcGgHHl2tvXrB7gnuSCYDes46AIw0NYjvLBZh-X-sPUJRgLJhBUCWn38b0K2IpUMnhmZs2LwJ-pB50sz3m8Hsuk5I2RdkZH6oLjD1Ahul_O3YlrWkiySFOfZWcseM3TGixtJmZUl5aTJ3yUQ_uwd8BivJu9lExxm312QHULE0dNqFchjuQmwhAQ_nnxZu3iHTbMug",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-04-04T21:35:04.987685Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-03-28T21:34:45+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.3YwluljnZGvEjtTBdV8T9yR_d5pXzQSJzT7MZJGh2R-Qq1H2CtXghxrUNvSbfrcMjx2QySI6I6swpJisabmbbE6Omx4_nNu2cqRpgsoEPCc-dAgVCuIkA_xTa-UDnidfkz3L_BvBmofMOZ3ofkG2eOc-o5evoqcGgHHl2tvXrB7gnuSCYDes46AIw0NYjvLBZh-X-sPUJRgLJhBUCWn38b0K2IpUMnhmZs2LwJ-pB50sz3m8Hsuk5I2RdkZH6oLjD1Ahul_O3YlrWkiySFOfZWcseM3TGixtJmZUl5aTJ3yUQ_uwd8BivJu9lExxm312QHULE0dNqFchjuQmwhAQ_nnxZu3iHTbMug'

// {
//   "access_token": "v2.local.CRabvHBtKQVNomAtipxlfevq361K4vEWruFO-rhD9iQRitRf-AR2ubW3_69ELLi9xODD7dvMyUcFHHtOF_RZMrDc82Uy9JF4qfhOoTxs87Ea7vNehoLg2WmOBNAmY0nTUG8pj9HTp_z6gV2ciOf9CeEhC_Fm-l9GLeBDxnC9zpqIT41vgptRRIuvX84TnWDS3Flo8bwlPifQlSOlhBzBSTFem2QkKDbT4E3P2UY1G29w8ZPIDOCviKEXUgArO0sgRa2GyIrA7J2WzLp0ElWPSdiFF0CDJcl54BOjoY2heEYHDpzXWR5y5XVtT0jrPrBXhbCuwijt0W1f0lFf4IGnndQK1Vxf",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-04-04T21:36:22.415458Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-03-28T21:36:19+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.CRabvHBtKQVNomAtipxlfevq361K4vEWruFO-rhD9iQRitRf-AR2ubW3_69ELLi9xODD7dvMyUcFHHtOF_RZMrDc82Uy9JF4qfhOoTxs87Ea7vNehoLg2WmOBNAmY0nTUG8pj9HTp_z6gV2ciOf9CeEhC_Fm-l9GLeBDxnC9zpqIT41vgptRRIuvX84TnWDS3Flo8bwlPifQlSOlhBzBSTFem2QkKDbT4E3P2UY1G29w8ZPIDOCviKEXUgArO0sgRa2GyIrA7J2WzLp0ElWPSdiFF0CDJcl54BOjoY2heEYHDpzXWR5y5XVtT0jrPrBXhbCuwijt0W1f0lFf4IGnndQK1Vxf'

// {
//   "access_token": "v2.local.4IgLoDe8gYWrTqbKvRo3Y0qx5HbFF1NuIBdqz8iXppVhQEHQAVOEZDSNP0HgvfcpcTcvMH_1FpRPfwghdhwVStDPQxkU0kIhcmPscbvxg4Lwi7aMB5xnJmH7tKiY9Cnjk5o-mBwAEWrH6j5oQyX2ZcVJhZBQWUzScxhHN-fJuzWgeorLiqMefonq3CxvnQ6UgmdR2BrHrykU_-0lMQjE-lb_2PmobTcSIkW-FjVhoYnArDhBXJZhQ00GrQzQownBFAU_0RjuwlMladKsK4yfvCZZwe5cboO-3b0gWbnTg4dJE2fzim9sdzK7D5KJAR-vWYeWGmV_lKeq_QI5nYnmLMSjUfU",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-04-04T21:38:22.460862Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.4IgLoDe8gYWrTqbKvRo3Y0qx5HbFF1NuIBdqz8iXppVhQEHQAVOEZDSNP0HgvfcpcTcvMH_1FpRPfwghdhwVStDPQxkU0kIhcmPscbvxg4Lwi7aMB5xnJmH7tKiY9Cnjk5o-mBwAEWrH6j5oQyX2ZcVJhZBQWUzScxhHN-fJuzWgeorLiqMefonq3CxvnQ6UgmdR2BrHrykU_-0lMQjE-lb_2PmobTcSIkW-FjVhoYnArDhBXJZhQ00GrQzQownBFAU_0RjuwlMladKsK4yfvCZZwe5cboO-3b0gWbnTg4dJE2fzim9sdzK7D5KJAR-vWYeWGmV_lKeq_QI5nYnmLMSjUfU'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
